import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// CRITICAL: Import PDF worker configuration BEFORE any PDF rendering
import './utils/pdfWorkerConfig';

import './styles/tailwind.css';
import './styles/index.css';

const root = ReactDOM?.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);